/**
 * Axios configuration is provided here.
 *
 * @remarks
 * All API calls reside in files with "Actions" suffix.
 * Please refrain from writing API calls in components unless absolutely necessary.
 */

import axios from "axios";
import { localstorageKeys } from "config";
import { getLocalStorageItem } from "utils";

const AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,

  headers: {
    "content-type": "application/json",
  },
});

AxiosInstance.interceptors.request.use(async (config) => {
  const userAuthTokens: { accessToken: string } = getLocalStorageItem(
    localstorageKeys.AUTH_TOKEN
  );

  const accessToken = userAuthTokens?.accessToken;

  if (Boolean(accessToken) && accessToken !== "") {
    return {
      ...config,
      headers: {
        ...config.headers,
        Authorization: `Bearer ${accessToken}`,
        // Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjYzN2I0ZTEyZTY4ZDJlNzAyOGFhMzliZCIsImlhdCI6MTY2OTAyNTI5OSwiZXhwIjoxNjY5MTExNjk5fQ.zdr1KZb6qgk4vBA5lFmOYvcu5bK9AfKw0CGMHFe0oSI`,
      },
    };
  }

  return config;
});

AxiosInstance.interceptors.response.use(
  (response) => response.data,

  async (error) => {
    if (
      error?.response?.data?.error === "Unauthorized" &&
      error?.response?.data?.statusCode === 401
    ) {
      // Logout & redirect
      const refreshToken = JSON.parse(
        localStorage.getItem("AUTH_TOKEN") ?? "{}"
      )?.refreshToken;
      if (refreshToken as boolean) {
        const resp = await axios({
          method: "POST",
          data: {
            refreshToken,
          },
          url: `${process.env.REACT_APP_API_URL ?? ""}auth/refresh-token`,
        });
        const data = await resp?.data;
        window.localStorage.setItem("AUTH_TOKEN", JSON.stringify(data?.token));
        location.reload();
      }
    }

    return await Promise.reject(error.response.data);
  }
);

export default AxiosInstance;
